<template>
  <section
    v-if="highlights.length > 0"
    class="feature-highlights"
  >
    <b-container>
      <b-row>
        <b-col>
          <div
            class="highlights"
            :class="`${highlightsLayoutClass}`"
          >
            <div
              v-for="(highlightItem, index) in highlights"
              :key="index"
              class="highlight-item"
            >
              <component
                :is="getLayoutComponent"
                :highlight="highlightItem"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>

import SpFeatureHighlightImageLeadlineTitleDescriptionButton from './highlight-layouts/image-leadline-title-description-button'
import SpFeatureHighlightQuote from './highlight-layouts/quote'

export default {
  name: 'sp-feature-highlight',
  components: {
    SpFeatureHighlightImageLeadlineTitleDescriptionButton,
    SpFeatureHighlightQuote
  },
  props: {
    highlights: {
      type: Array,
      required: true
    },
    highlightsStyle: {
      type: String,
      default: 'image-leadline-title-description-button'
    },
    highlightsLayout: {
      type: String,
      default: 'striped_right'
    }
  },
  computed: {
    getLayoutComponent() {
      return `sp-feature-highlight-${this.highlightsStyle}`
    },
    highlightsLayoutClass() {
      switch (this.highlightsLayout) {
      case 'striped_left':
        return 'striped-image-left'

      case 'image_left':
        return 'image-left'

      case 'image_right':
        return 'image-right'

      case 'striped_right':
      default:
        return 'striped-image-right'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.highlight-item div {
  display: flex;
  flex-direction: row;
  border-top: 1px solid;
  border-color: var(--main-border-color);
  padding: 3em 0em;
  flex-direction: column;

  @include media-breakpoint-up(sm) {
    flex-direction: row;
  }
}

::v-deep  .image-right {
  @include media-breakpoint-up(sm) {

    .highlight-item > div {
      flex-direction: row-reverse;

      .highlight-image {
        margin-left: 3em;
      }

    }
  }
}

::v-deep  .image-left {
  @include media-breakpoint-up(sm) {

    .highlight-item > div {
      .highlight-image {
        margin-right: 3em;
      }
    }
  }
}

::v-deep  .striped-image-left {
  @include media-breakpoint-up(sm) {

    .highlight-item {

      &:nth-child(even) {
        > div {
          flex-direction: row-reverse;

          .highlight-image {
            margin: 0 0 0 3em;
          }
        }
      }

      .highlight-image {
        margin: 0 3em 0 0;
      }
    }
  }
}

::v-deep  .striped-image-right {
  @include media-breakpoint-up(sm) {

    .highlight-item {

      .highlight-image {
        margin: 0 3em 0 0;
      }

      &:nth-child(odd) {
        > div {
          flex-direction: row-reverse;

          .highlight-image {
            margin: 0 0 0 3em;
          }
        }
      }
    }
  }
}
</style>
